<div class="banner">
  <div class="banner-content">
    <button>
      {{'FEATURES.BANNER.ENTERPRISE_SERVICES' | transloco}}
    </button>
    <h2>{{ 'FEATURES.BANNER.TITLE' | transloco }}</h2>
    <p class="pt-4 fs-16">{{ 'FEATURES.BANNER.SUBTITLE' | transloco }}</p>
  </div>
  <div class="flex flex-row mt-20 pt-24 service-info">
    <div class="banner-cards mr-16">
      <div class="card-title">{{'FEATURES.BANNER.ACTIVE_SERVICES' | transloco}}</div>
      <div class="count">{{ activeServicesCount }}</div>
    </div>
    <div class="banner-cards">
      <div class="card-title">{{'FEATURES.BANNER.ENVIRONMENTS' | transloco}}</div>
      <div class="count service-count">{{ environmentsCount }}</div>
    </div>
  </div>
</div>
